import { createWebHistory, createRouter } from 'vue-router'
import routes from './routes'
import appConfig from '../../app.config'
import { DateTime } from 'luxon'

const defaultDate = DateTime.now().setZone('America/Mexico_City').toISO()

const router = createRouter({
  history: createWebHistory(),
  routes,
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0, left: 0 }
    }
  }
})

// Before each route evaluates...
router.beforeEach(async (routeTo, routeFrom, next) => {
  const authRequired = routeTo.matched.some((route) => route.meta.authRequired)

  if (!authRequired) return next()

  const tokenDate = localStorage.getItem('expiresIn')
  const expirationToken = DateTime.fromSeconds(parseInt(tokenDate)).toISO()
  if (defaultDate <= expirationToken) {
    next()
  } else {
    localStorage.removeItem('user')
    localStorage.removeItem('email')
    localStorage.removeItem('language')
    localStorage.removeItem('avatar')
    localStorage.removeItem('producer')
    localStorage.removeItem('token')
    localStorage.removeItem('expiresIn')
    next({ name: 'login', query: { redirectFrom: routeTo.fullPath } })
  }
})

router.beforeResolve(async (routeTo, routeFrom, next) => {
  try {
    for (const route of routeTo.matched) {
      await new Promise((resolve, reject) => {
        if (route.meta && route.meta.beforeResolve) {
          route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
            if (args.length) {
              next(...args)
              reject(new Error('Redirected'))
            } else {
              resolve()
            }
          })
        } else {
          resolve()
        }
      })
    }
  } catch (error) {
    return
  }
  document.title = routeTo.meta.title + ' | ' + appConfig.title
  next()
})

export default router
